module.exports = __webpack_public_path__ + "img/20.a7592f5d.svg";